<div class="crear-odontograma">
  <div class="acciones-top">
    <button mat-stroked-button type="button" (click)="empezarNuevo()">Empezar nuevo</button>
    <button mat-stroked-button type="button" (click)="precargarUltimo()" [disabled]="!ultimoFecha">
      Precargar último{{ ultimoFecha ? " (" + ultimoFecha + ")" : "" }}
    </button>
    <mat-button-toggle-group [(ngModel)]="denticion" class="denticion-toggle">
      <mat-button-toggle value="adulto">Adulto</mat-button-toggle>
      <mat-button-toggle value="nino">Niño</mat-button-toggle>
      <mat-button-toggle value="mixta">Mixta</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <mat-tab-group>
    <mat-tab label="Odontograma">
      <app-odontograma-chart
        [estado]="estado"
        [mode]="'edit'"
        [denticion]="denticion"
        (surfaceClick)="onSurfaceClick($event)"
        (toothLabelClick)="onToothLabelClick($event)"
      ></app-odontograma-chart>

      <span
        [matMenuTriggerFor]="caraMenu"
        #caraMenuTrigger="matMenuTrigger"
        [style.position]="'fixed'"
        [style.left.px]="menuX"
        [style.top.px]="menuY"
      ></span>
      <mat-menu #caraMenu="matMenu">
        <button mat-menu-item *ngFor="let c of condicionesCara" (click)="setCaraCondicion(c.codigo)">
          <span class="swatch" [style.background]="c.color"></span> {{ c.label }}
        </button>
        <button mat-menu-item (click)="setCaraCondicion(null)">Sin hallazgo</button>
        <button mat-menu-item (click)="abrirPopoverDiente(fdiSeleccionado)">Más opciones…</button>
      </mat-menu>
    </mat-tab>
  </mat-tab-group>

  <div class="acciones-bottom" *ngIf="mostrarGuardar">
    <button mat-flat-button class="btn-guardar-odontograma" (click)="guardar()" [disabled]="guardando">
      Guardar
    </button>
  </div>
</div>
